<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationCode" allowClear :placeholder="language['column.pleaseChoose']+language['premission.applicationName']">
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.applicationCode">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['messageTemplatemanagement.templateCode']">
              <a-input :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateCode']" v-model="queryParam.templateCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['messageTemplatemanagement.templateContent']">
              <a-input :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateContent']" v-model="queryParam.templateContent"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['messageTemplatemanagement.templateName']">
                <a-input :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateName']" v-model="queryParam.templateName"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['messageTemplatemanagement.templateType']">
                <!--<a-input placeholder="请输入模板类型" v-model="queryParam.templateType"></a-input>-->
                <j-dict-select-tag  v-model="queryParam.templateType" :triggerChange="true" dictCode="msgType"  :placeholder="language['common.pleaseInput']+language['messageTemplatemanagement.templateType']">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'sysMessageTemplate:insert'">{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('消息模板')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"
                @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel" v-has="'sysMessageTemplate:delete'">
            <a-icon type="delete"/>
            {{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <!-- 字符串超长截取省略号显示-->
        <span slot="templateContent" slot-scope="text">
          <j-ellipsis :value="text" :length="25" />
        </span>
        <template slot="templateType" slot-scope="text">
          <span v-if="text == 1">{{language['common.sms']}}</span>
          <span v-else-if="text == 2">{{language['common.email']}}</span>
          <span v-else-if="text == 3">{{language['common.WeChat']}}</span>
          <span v-else-if="text == 4">{{language['common.system']}}</span>
        </template>


        <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" v-has="'sysMessageTemplate:edit'">{{language['common.edit']}}</a>

            <a-divider type="vertical" v-has="'sysMessageTemplate:edit'"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'sysMessageTemplate:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <a @click="handleTest(record)">{{language['messageTemplatemanagement.sendTest']}}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysMessageTemplate-modal ref="modalForm" @ok="modalFormOk"></sysMessageTemplate-modal>

    <sysMessageTest-modal ref="testModal"></sysMessageTest-modal>
  </a-card>
</template>

<script>
  import SysMessageTemplateModal from './modules/SysMessageTemplateModal'
  import SysMessageTestModal from './modules/SysMessageTestModal'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JEllipsis from "@/components/jeecg/JEllipsis";
  import { deleteAction, postAction, getAction ,httpAction} from '@/api/manage'

  export default {
    name: "SysMessageTemplateList",
    mixins: [JeecgListMixin],
    components: {
      JEllipsis,
      SysMessageTemplateModal,
      SysMessageTestModal
    },
    data() {
      return {
        application:{},
        applicationList:[],
        // description: '消息模板管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.$store.getters.language['messageTemplatemanagement.templateCode'],
            align: "center",
            dataIndex: 'templateCode'
          },
          {
            title: this.$store.getters.language['messageTemplatemanagement.templateName'],
            align: "center",
            dataIndex: 'templateName'
          },
          {
            title: this.$store.getters.language['messageTemplatemanagement.templateContent'],
            align: "center",
            dataIndex: 'templateContent',
            scopedSlots: {customRender: 'templateContent'},
          },
          {
            title: this.$store.getters.language['messageTemplatemanagement.templateType'],
            align: "center",
            dataIndex: 'templateType',
            scopedSlots: {customRender: 'templateType'},
            /*customRender: function (text) {
              if(text=='1') {
                return "短信";
              }
              if(text=='2') {
                return "邮件";
              }
              if(text=='3') {
                return "微信";
              }
              if(text=='4') {
                return "系统";
              }
            }*/
          },
          {
            title: this.$store.getters.language['common.action'],
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
        url: {
          list: this.$store.getters.application.applicationType=='platform'?"/sys/message/sysMessageTemplate/list":"/sys/message/sysMessageTemplate/list?applicationCode="+this.$store.getters.applicationCode,
          delete: "/sys/message/sysMessageTemplate/delete",
          deleteBatch: "/sys/message/sysMessageTemplate/deleteBatch",
          exportXlsUrl: "sys/message/sysMessageTemplate/exportXls",
          importExcelUrl: "sys/message/sysMessageTemplate/importExcel",
        },
      }
    },
    created () {
      this.application = this.$store.getters.application;
      if(this.application.applicationType === 'platform') {
        this.getApplicationList();
      }
      console.log('applicationCode:'+this.$store.getters.applicationCode)
      console.log('applicationtype:'+this.$store.getters.application.applicationType)
      // this.getThisapplication();
    },
    watch:{
      /*url:{
        immediate: true,
          deep: true,
          handler(val) {
            alert(val.list);
            console.log('applicationCode:'+this.$store.getters.applicationCode)
            console.log('applicationtype:'+this.$store.getters.application.applicationType)
           },
      }*/
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      getApplicationList(){
        httpAction("/sys/sysBmApplication/queryList", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
      handleTest(record){
        this.$refs.testModal.open(record);
        this.$refs.testModal.title = this.language["messageTemplatemanagement.sendTest"];
      },
      searchReset() {
        if(this.application.applicationType === 'platform'){
          this.queryParam ={
            applicationCode:null
          }
        }else{
          this.queryParam ={
            applicationCode:this.$store.getters.applicationCode
          }
        }
        this.loadData(1);
      },
      handleEdit(record){
        this.$refs.modalForm.actionType = 'edit'
        this.$refs.modalForm.edit(record,this.application);
      },
      handleAdd(){
        this.$refs.modalForm.actionType = 'add'
        this.$refs.modalForm.add(this.application);
      }
    }
  }
</script>
<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .ant-card-body .table-operator {
    margin-bottom: 18px;
  }

  .ant-table-tbody .ant-table-row td {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .anty-row-operator button {
    margin: 0 5px
  }

  .ant-btn-danger {
    background-color: #ffffff
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }
</style>